import { writable } from "svelte/store";
import * as api from "../apis/shipMng.api";

export async function apiGetShipMng(shipmnt_no) {
    try {
        const response = await api.apiGetShipMng(shipmnt_no);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetShipMngDetail() {
    try {
        const response = await api.apiGetShipMngDetail();

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPostShipMng(shipmnt_no, barcodeList) {
    try {
        let formData = {
            shipmnt_no: shipmnt_no,
            barcodeList: barcodeList,
        };

        const response = await api.apiPostShipMng(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return true;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
